module.exports = __webpack_public_path__ + "static/media/tokyo-bitcoin.5251479f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/HomePageResources/tokyo-bitcoin.svg
// module id = 105
// module chunks = 0